import AxiosStatic from "axios";
import BusinessSignup from "./business-signup";
import ChecklistItem from "./checklist-item";

class BusinessService {
    $http = AxiosStatic
    async getBusinessDetails() {
      return this.$http
        .post("/api/business/getBusinessDetails")
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async getAllLinkedBusinessDetails() {
      return this.$http
        .get("/api/business/getAllLinkedBusinessDetails")
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async getStartMonthOptions() {
      return this.$http
        .post("/api/business/getStartMonthOptions?yearStructure=financial")
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async getXeroLog(skip: number, take:number, sortDirection: string, showError: boolean) {
      return this.$http
        .post("/api/business/getXeroLog?skip="+skip+"&take="+take+"&sortDirection="+ sortDirection+"&showError="+ showError)
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }


    async getConnectedAccounts() {
      return this.$http
        .post("/api/business/GetConnectedAccounts")
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async getIncomeData(selectedPeriod: any = null) {
      return this.$http
        .post("/api/business/GetIncomeData?selectedPeriod=" + selectedPeriod)
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async getExpenseData(selectedPeriod: any = null) {
      return this.$http
        .post("/api/business/GetExpenseData?selectedPeriod=" + selectedPeriod)
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async getCashSummaryData() {
      return this.$http
        .post("/api/business/getCashSummaryData")
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async completeSignup(signupData: any) {
      return this.$http.post("/api/Business/CompleteSignup", signupData).catch(this.formatErrorsAndRethrow);
    }

    async saveProfitLossHistoricalDataIncome(incomeData: any) {
      return this.$http.post("/api/Business/SaveProfitLossHistoricalDataIncome", incomeData).catch(this.formatErrorsAndRethrow);
    }

    async saveProfitLossHistoricalDataExpense(expenseData: any) {
      return this.$http.post("/api/Business/SaveProfitLossHistoricalDataExpense", expenseData).catch(this.formatErrorsAndRethrow);
    }

    async saveProfitLossTradingDataIncome(incomeData: any) {
      return this.$http.post("/api/Business/SaveProfitLossTradingDataIncome", incomeData).catch(this.formatErrorsAndRethrow);
    }

    async saveProfitLossTradingDataExpense(expenseData: any) {
      return this.$http.post("/api/Business/SaveProfitLossTradingDataExpense", expenseData).catch(this.formatErrorsAndRethrow);
    }

    async saveProfitLossForecastData(incomeData: any, expenseData: any, selectedPeriod: any = null) {
      return this.$http.post("/api/Business/SaveProfitLossForecastData", { income: incomeData, expense: expenseData, selectedPeriod: selectedPeriod}).catch(this.formatErrorsAndRethrow);
    }

    async saveForecastFinancialYearOriginalTotalData(incomeData: any, expenseData: any) {
      return this.$http.post("/api/Business/SaveForecastFinancialYearOriginalTotalData", { income: incomeData, expense: expenseData}).catch(this.formatErrorsAndRethrow);
    }

    async getServiceReviewData(data: any) {
      return this.$http
        .post("/api/business/GetServiceReviewData", data)
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async reconnectXeroAccount(data: any) {
      return this.$http
        .post("api/business/reconnectXeroAccount", data)
        .catch(this.formatErrorsAndRethrow)
    }

    async removeXeroConnection(data: any) {
      return this.$http
        .post("api/business/RemoveConnection", data)
        .catch(this.formatErrorsAndRethrow);
    }

    async disconnectXero(clearSignupAccounts: boolean) {
      return this.$http
        .post("api/business/DisconnectXeroAccount?clearSignupAccounts=" + clearSignupAccounts)
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async resyncFromService(initialSync: Boolean, reviewAccountData: any, prioritySystemSync: Boolean | undefined) {
      var data = {
        reviewAccountData,
        initialSync,
        prioritySystemSync
      };

      return this.$http
        .post("/api/business/ResyncFromService", data)
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })        
    }

    async getExpenseAccounts(defaultAccounts: boolean, checkAbleToHideOrDelete: boolean) {
      const value = {
        defaultAccounts: defaultAccounts,
        checkAbleToHideOrDelete: checkAbleToHideOrDelete
      }
      return this.$http
        .post("/api/business/getExpenseAccounts", value)
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async getExpenseAccountTypes() {
      return this.$http
        .post("/api/business/getExpenseAccountTypes")
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async saveExpenseAccounts(accounts: any) {
        return this.$http.post("/api/Business/SaveExpenseAccounts", accounts)
            .catch(this.formatErrorsAndRethrow);
    }

    saveBusinessDetails(business: BusinessSignup, primaryContactID: number) {
        return this.$http.post("/api/Business/Save?primaryContactID=" + primaryContactID, business)
            .catch(this.formatErrorsAndRethrow);
    }

    async archiveOrganisation(businessID: Number) {
      return await this.$http.post("/api/Business/Archive?businessID=" + businessID)
        .catch(this.formatErrorsAndRethrow);
    }

    async unarchiveOrganisation(businessID: Number) {
      return await this.$http.post("/api/Business/Unarchive?businessID=" + businessID)
        .catch(this.formatErrorsAndRethrow);
    }

    async deleteOrganisation(businessID: Number) {
      return await this.$http.post("/api/Business/Delete?businessID=" + businessID)
        .catch(this.formatErrorsAndRethrow);
    }

    isLastMonthOfBusinessYear() {
      return this.$http
        .post("/api/business/isLastMonthOfBusinessYear")
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    getHasEndedYear() {
      return this.$http
        .post("/api/business/getBusinessHasEndedYear")
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    getBusinessCurrentPreviousYear(selectedPeriod: any = null) {
      return this.$http
        .post("/api/business/getBusinessCurrentPreviousYear?selectedPeriod=" + selectedPeriod)
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async getCurrentMonthChecklist() {
      return this.$http
        .post("/api/business/getCurrentMonthChecklist")
        .then(response => {
          if (response.data) {
              return response.data;
          }
          else {
              throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow);
    }

    async saveCurrentMonthChecklistItem(item: ChecklistItem) {
      return this.$http
        .post("/api/business/saveCurrentMonthChecklist", item)
        .catch(this.formatErrorsAndRethrow);
    }

    async getDebugSpreadsheet(id: number) {
      return this.$http
        .get("/api/business/getDebugSpreadsheet")
        .catch(this.formatErrorsAndRethrow);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async getUsersInBusiness(excludeSelf: Boolean = true) : Promise<any> {
      return this.$http
        .post("/api/business/getUsersInBusiness?excludeSelf=" + excludeSelf)
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async checkSupportedRegion(token: any) {
      return this.$http
        .post("/api/business/checkSupportedRegion", token)
        .then(response => {
          if (response.data) {
            return response.data;
          }
          else {
            throw new Error("An unexpected error has occurred");
          }
        })
        .catch(this.formatErrorsAndRethrow)
    }

    async setTutorialWizardCompleted(businessID: number) {
      return this.$http
        .post("/api/business/tutorialWizardCompleted?businessID=" + businessID)
        .catch(this.formatErrorsAndRethrow)
    }

    async setCashSummaryVisited(businessID: number) {
      return this.$http
        .post("/api/business/cashSummaryVisited?businessID=" + businessID)
        .catch(this.formatErrorsAndRethrow)
    }

    mapReviewAccountToType(account: any) {
      var expenseAccountTypeID = 3;
      var expenseAccountDescription = "Expense";

      if (account.accountType == 7) {
        expenseAccountTypeID = 5;
        expenseAccountDescription = "Other Income";
      } else if (account.accountType == 5) {
        expenseAccountTypeID = 5;
        expenseAccountDescription = "Revenue";
      } else if (account.accountType == 6) {
        expenseAccountTypeID = 5;
        expenseAccountDescription = "Direct Cost";
      } else if (account.accountType == 1) {
        expenseAccountTypeID = 1;
        expenseAccountDescription = "Wages";
      } else if (account.accountType == 2) {
        expenseAccountTypeID = 2;
        expenseAccountDescription = "Super";
      } else if (account.accountType == 4) {
        expenseAccountTypeID = 4;
        expenseAccountDescription = "Workcover";
      }

      return {
        expenseAccountTypeID: expenseAccountTypeID,
        description: expenseAccountDescription
      };
    }

    mapReviewDataToViewModels(accountList: any) {
      var dataImport: any = [];
      var index = 0;

      accountList.forEach((account: any) => {
        var accountType = this.mapReviewAccountToType(account);

        var newAccount = {
          id: index++,
          name: account.name,
          previousYear: account.previousYearAmount > 0 ? account.previousYearAmount.toFixed(2) : account.previousYearAmount,
          ytd: account.yearToDateAmount > 0 ? account.yearToDateAmount.toFixed(2) : account.yearToDateAmount,
          expenseAccountType: accountType,
          typeID: accountType.expenseAccountTypeID,
          hasGST: account.gstInclusive,
          excludesGST: !account.gstInclusive,
          disabled: accountType.expenseAccountTypeID == 5, // Sales/Purchases/OtherIncome
          hidden: account.hidden,
          ableToHide: accountType.expenseAccountTypeID != 5 && account.previousYearAmount <= 0 && account.yearToDateAmount <= 0
        };

        dataImport.push(newAccount);
      });

      return dataImport;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private formatErrorsAndRethrow(error: any) {
      if (error.response) {
          let err = error.response.data;
          if (err.errors) {
              err = [...Object.keys(error.response.data.errors).map(
                  key => error.response.data.errors[key]
              )];
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              err = err.reduce((flat: any, list: any) => flat.concat(list));
              console.log(err);
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              err = err.reduce((val: any, arr: any) => `${val} \r\n${arr}`, "")
          }
          throw new Error(err);
      }
      else {
          console.log("error", error);
          throw new Error("An unexpected error has occurred");
      }
  }
}

export default new BusinessService();
